"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.superEncode = exports.mapMultiWords = exports.properCase = exports.removeKebabCase = exports.kebabCase = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.escapeRegExpChars = escapeRegExpChars;

var _maps = require("../maps");

var kebabCase = exports.kebabCase = function kebabCase(str) {
  //remove special characters, lowercase, replace space with dash
  return str.replace(/[^a-z0-9\s]/gi, "").toLowerCase().split(" ").join("-");
};

var removeKebabCase = exports.removeKebabCase = function removeKebabCase(_ref) {
  var str = _ref.str,
      _ref$map = _ref.map,
      map = _ref$map === undefined ? _maps.KebabMap : _ref$map,
      noCapital = _ref.noCapital;

  if (typeof str !== 'string') {
    console.error('Expected \'str\' to be string but received:', typeof str === "undefined" ? "undefined" : _typeof(str));
  }

  if (map[str]) {
    str = map[str];
  } else {
    str = str.split('-').map(function (s) {
      return map[s] ? map[s] : noCapital ? s : s.charAt(0).toUpperCase() + s.substring(1);
    }).join(' ');
  }
  return str;
};

/**
 * Will try to match and replace every word from str against the Kebab map.
 * In addition words can be capitalized. Use capitalize option.
 * 
 * @param {string} options.capitalize Use "first" to capitalize first word only; use "all" to capitalize all words.
 */
var properCase = exports.properCase = function properCase(_ref2) {
  var str = _ref2.str,
      _ref2$map = _ref2.map,
      map = _ref2$map === undefined ? _maps.KebabMap : _ref2$map,
      _ref2$capitalize = _ref2.capitalize,
      capitalize = _ref2$capitalize === undefined ? "" : _ref2$capitalize;

  if (typeof str !== 'string') {
    console.error('Expected \'str\' to be string but received:', typeof str === "undefined" ? "undefined" : _typeof(str));
    return str;
  }

  var result = str.split(" ").reduce(function (words, word, idx) {
    if (capitalize === "all" || capitalize === "first" && idx === 0) {
      word = word.charAt(0).toUpperCase() + word.slice(1);
    }
    words.push(map[word.toLowerCase()] || word);
    return words;
  }, []).join(" ");

  return result;
};

var mapMultiWords = exports.mapMultiWords = function mapMultiWords(_ref3) {
  var str = _ref3.str,
      _ref3$map = _ref3.map,
      map = _ref3$map === undefined ? _maps.MultiWordsMap : _ref3$map;

  if (typeof str !== 'string') {
    console.error('Expected \'str\' to be string but received:', typeof str === "undefined" ? "undefined" : _typeof(str));
  }

  Object.keys(map).forEach(function (key) {
    str = (" " + str + " ").split(new RegExp(" " + key + " ", 'i')).join(" " + map[key] + " ");
  });
  return str.trim();
};

/**
 * Will escape all special regexp characters.
 * 123[^4-9]$ ---> will become ---> 123\[\^4\-9\]\$
 */
function escapeRegExpChars(str) {
  return str.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

/**
 * Encodes additional characters that encodeURIComponent doesn't normally encode.
 * Encoded string can be decoded with regular decodeURIComponent() function.
 */
var superEncode = exports.superEncode = function superEncode(str) {
  return encodeURIComponent(str).replace(/[.!'()*_\-]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16);
  });
};